import { Box, Typography, Divider } from '@mui/material';
import { useTranslation, Types } from '@scorenco/core';

import { T_KEYS } from '@/translations';

import { MemberCard } from './_internal/MemberCard';

type Member = Types.Teams_Team_In_Season_Has_Member;

interface PlayersWidgetProps {
  members?: Member[] | null;
}

const getNumberFromUnknown = (value: unknown): number | undefined =>
  typeof value === 'number' ? value : undefined;

export const PlayersWidget = ({ members }: PlayersWidgetProps) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ width: '100%', marginBottom: '1.5rem', padding: '0 5%' }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t(T_KEYS.TEAMS_PLAYERS_STAFF)}
      </Typography>
      <Box
        sx={{
          mt: 1,
          mb: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        {!members?.filter((member) => member.is_staff).length && (
          <>
            <Typography variant="body1" component="p" sx={{ mt: 2, mb: 2 }}>
              {t(T_KEYS.TEAMS_PLAYERS_STAFF_NOBODY)} <span role="img">😮</span>
            </Typography>
          </>
        )}
        {members
          ?.filter((member) => member.is_staff)
          .map((staff, index) => (
            <>
              <MemberCard
                member={staff}
                publicName={staff.public_name ?? ''}
                userRole={staff.role ?? ''}
                pictureUrl={staff.photo ?? ''}
                key={index}
              />
              <Divider />
            </>
          ))}
      </Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t(T_KEYS.TEAMS_PLAYERS_PLAYERS)}
      </Typography>
      <Box
        sx={{
          mt: 1,
          mb: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        {!members?.filter((member) => !member.is_staff).length && (
          <>
            <Typography variant="body1" component="p" sx={{ mt: 2, mb: 2 }}>
              {t(T_KEYS.TEAMS_PLAYERS_PLAYERS_NOBODY)}{' '}
              <span role="img">😮</span>
            </Typography>
          </>
        )}
        {members
          ?.filter((member) => !member.is_staff)
          .map((player, index) => (
            <>
              <MemberCard
                member={player}
                publicName={player.public_name ?? ''}
                userRole={player.role ?? ''}
                userNumber={getNumberFromUnknown(player.number)}
                pictureUrl={player.photo ?? ''}
                key={index}
              />
              <Divider />
            </>
          ))}
      </Box>
    </Box>
  );
};
